import { useCallback } from 'react'
import { CatalogAlias } from '../../types/catalogReview'
import { ActionsCell, TD, TR } from '../../components/ui/Table'
import { Badge } from '../../components/ui/Badge'
import { Button } from '../../components/ui/Button'

interface Props {
  alias: CatalogAlias
  onUndo: (alias: CatalogAlias) => void
}

export function AliasRow({ alias, onUndo }: Props) {
  const handleUndo = useCallback(() => onUndo(alias), [alias, onUndo])

  return (
    <TR>
      <TD>{alias.text}</TD>
      <TD>
        {alias.status === 'mapped' ? (
          <Badge color="green">→ {alias.target?.name ?? '—'}</Badge>
        ) : (
          <Badge color="gray">Dismissed</Badge>
        )}
      </TD>
      <TD>{alias.createdBy ?? '—'}</TD>
      <TD>{new Date(alias.createdAt).toLocaleDateString()}</TD>
      <ActionsCell>
        <Button variant="ghost" size="sm" onClick={handleUndo}>
          Undo
        </Button>
      </ActionsCell>
    </TR>
  )
}
